import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector, shallowEqual, useDispatch } from 'react-redux';
import Badge from '../../atoms/badge/badge';
import Label from '../../atoms/label/label';
import swal from 'sweetalert';
import { IconType } from '../../atoms/icon/icon';
import Button, { ButtonTheme } from '../../atoms/button/button';
import Modal, { ModalSize } from '../../molecules/modal/modal';
import { getItems, createItem, removeItem, tableEdited, updateItems, getSortedItems } from '../../../store/externalCalls/api/secondaryListTableApi';
import TableSection from '../tableSection/tableSectionv2';
import { storeStructure } from '../../../store/reducers';
import { appendParamsToURL, composeURL, checkObjectAttributes } from '../../../utils/urlTools';

const FormRelationship = (props) => {
  const {
    value, helpText, label, isForm, configFile, onChange, 
    onCreate, onDelete, onSave, buttonColor,id,customParams,disabled,maxElements,onSelectUrl,canEdit
  } = props;
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [paginateValues, setPaginatedValues] = useState([]);
  const [updatedValues, setUpdateValues] = useState();
  const [errors, setErrors] = useState({});
  const session = useSelector((state) => state[storeStructure.Session], shallowEqual);
  const [itemsSelected, setItemsSelected] = useState(value);
  const [disabledValue,setDisabledValue] =useState(disabled);
  let valueParams=(customParams?JSON.parse(customParams):null);
  const getData = (changePage) => {
    if (checkObjectAttributes((valueParams? valueParams : session), configFile.sessionParams)) {
      getItems(changePage || composeURL((valueParams?valueParams:session), configFile.sessionParams, configFile.getURL))
        .then((paginatedItems) => {
          setPaginatedValues(paginatedItems);
          setOpenModal(true);
          (value.length > 0) ? setItemsSelected(value) : setItemsSelected(itemsSelected);
        });
    }
  };
  const handlerChangePage = (e) => {
    getData(e);
  };
  const handlerOpenModal = () => {
    setItemsSelected(value);
    getData();
  };
  useEffect(() => {
    if(maxElements && value.length>=maxElements){
      setDisabledValue(true);
    }else
      setDisabledValue(disabled);
  },[value]);
  useEffect(()=>{
    setDisabledValue(disabled);
  },[disabled])

  const handlerErrors = (e) => {
    const messages = e.errors === undefined ? { general: 'Something was wrong' } : e.errors;

    setErrors(messages);
    setTimeout(() => {
      setErrors({});
    }, 5000);
  };

  const handlerCreate = (item) => {
    setErrors({});
    console.log("create");
    const url = composeURL((valueParams?valueParams:session), configFile.sessionParams, configFile.createURL, id);
    createItem(
      url,
      item,
      dispatch,
    ).then(() => {
      // eslint-disable-next-line max-len
      getItems(composeURL((valueParams?valueParams:session), configFile.sessionParams, configFile.getURL)).then((paginatedItems) => {
        setPaginatedValues(paginatedItems);
        setOpenModal(true);
      });
    }, (e) => {
      handlerErrors(e);
    });
  };
  const handlerRemoveItem = (item) => {
    swal({
      title: 'Are you sure?',
      text: 'You are removing a item.',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const url = composeURL((valueParams?valueParams:session), configFile.sessionParams, configFile.removeURL, id);
        removeItem(url, item, dispatch).then((result) => {
          getData();
          onDelete(result);
        }, (e) => {
          handlerErrors(e);
        });
      }
    });
  };
  const handlerUpdate = (dataSet) => {
    setUpdateValues(dataSet);
    console.log("update");
    if (configFile.autoUpdate === true) {
      const url = composeURL((valueParams?valueParams:session), configFile.sessionParams, configFile.updateURL, id);

      updateItems(url, dataSet, dispatch)
        .then(() => {
          onSave();
        }, (e) => {
          handlerErrors(e);
        });
    } else {
      tableEdited(dispatch);
    }
  };
  const handlerClickRow = (newItemSelected) => {
    setItemsSelected(newItemSelected);
  };

  const handlerCloseModal = () => {
    setOpenModal(false);
  };

  const handlerSave = () => {
    onChange({ target: { value: itemsSelected } });
    setItemsSelected([]);
    handlerCloseModal();
  };

  const handlerOnClickBadge = (item) => {
    if (configFile.tableConfig.isMultiSelectable) {
      const newItems = [...value];
      newItems.splice(newItems.indexOf(item), 1);
      onChange({ target: { value: newItems } });
    } else {
      onChange({ target: { value: {} } });
    }
  };
   const handlerSearch = (filters) => {
    if(configFile.getDataPostUrl){
      getData(undefined,filters)
    }else{
      const url = composeURL((valueParams?valueParams:session), configFile.sessionParams, configFile.getURL);
      const searchURL = appendParamsToURL(url, filters);
      getItems(searchURL).then((response) => {
       setPaginatedValues(response);
      });
    }
  };
    const handlerSort = (sort) => {
      const { attributeName, sortDown } = sort;
      const orderList = sortDown ? 'asc' : 'desc';
      const obj = {
        sort_by: attributeName,
        order: orderList,
      };
      const url = composeURL((valueParams?valueParams:session), configFile.sessionParams, configFile.getURL);
      const searchURL = appendParamsToURL(url, obj);
      getSortedItems(searchURL, dispatch).then((response) => {
       setPaginatedValues(response);
      });
    };
    const getItemName = (item) => {
      const itemNames = Array.isArray(configFile.itemName)
        ? configFile.itemName
        : [configFile.itemName];

      return itemNames.find((name) => item?.[name] !== undefined && item?.[name] !== null)
        ? item[itemNames.find((name) => item?.[name] !== undefined && item?.[name] !== null)]
        : '';
    };
  return (
    <div className={isForm === true ? 'form-group row' : ''}>
      { label !== ''
        && (
          <Label helpText={helpText}>{label}</Label>
        )}
      <div className={isForm === true ? 'col-sm-8' : ''}>
        {canEdit && Array.isArray(value) && value.map((val) => (
          <Badge
            className="mr-1"
            key={val[configFile.itemId]}
            icon={IconType.CLOSE}
            onClick={() => handlerOnClickBadge(val)}
          >
            {getItemName(val)}
          </Badge>
        ))}
        {!canEdit && Array.isArray(value) && value.map((val) => (
          <Badge
            className="mr-1"
            key={val[configFile.itemId]}
          >
            {getItemName(val)}
          </Badge>
        ))}
        {!Array.isArray(value) && value[configFile.itemId] !== undefined
          && (
            !canEdit ? (
              <Badge
                className="mr-1"
                key={value[configFile.itemId]}
              >
                {getItemName(value)}
              </Badge>
            ) : (
              <Badge
                className="mr-1"
                key={value[configFile.itemId]}
                icon={IconType.CLOSE}
                onClick={() => handlerOnClickBadge(value)}
              >
                {getItemName(value)}
              </Badge>
            ))}
        {canEdit && (configFile.isMultiSelectable || value[configFile.itemId] === undefined)
          && (
            <Button id={id}
              theme={buttonColor ? buttonColor : ButtonTheme.PRIMARY}
              icon={IconType.NEW}
              disabled={disabledValue}
              onClick={handlerOpenModal}
            />
          )}
          {value.length>=maxElements && <> (reached max of items allowed)</>}
      </div>
      { openModal === true
      && (
        <Modal
          title={configFile.title}
          onClose={handlerCloseModal}
          size={ModalSize.LARGE}
          dialogClassName={configFile?.dialogClassName || ''}
        >
          <TableSection
            configFile={configFile.tableConfig}
            valuesPaginated={paginateValues}
            onChangePage={handlerChangePage}
            onClickRow={handlerClickRow}
            onChangeItem={handlerUpdate}
            onClickCreate={handlerCreate}
            onClickRemoveItem={handlerRemoveItem}
            maxElementsSelectable={maxElements}
            onSelectUrl={onSelectUrl}
            onSearch={handlerSearch}
            onSort={handlerSort}
            initDataSelected={configFile.tableConfig.isMultiSelectable === true ? itemsSelected : []}
          />
          <div>
            <Button
              theme={ButtonTheme.PRIMARY}
              onClick={handlerSave}
              disabled={itemsSelected === undefined}
            >
              Ok
            </Button>
          </div>
        </Modal>
      )}
    </div>
  );
};

FormRelationship.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),PropTypes.oneOf([null])

  ]),
  configFile: PropTypes.shape({
    itemId: PropTypes.string,
    getURL: PropTypes.string,
    itemName: PropTypes.string,
    createURL: PropTypes.string,
    removeURL: PropTypes.string,
    autoUpdate: PropTypes.bool,
    updateURL: PropTypes.string,
    idAttribute: PropTypes.string,
    title: PropTypes.string,
    sessionParams: PropTypes.arrayOf(PropTypes.string),
    tableConfig: PropTypes.shape({
      isMultiSelectable: PropTypes.bool,
    }),
  }).isRequired,
  onSelectUrl:PropTypes.string,
  maxElements:PropTypes.number,
  onChange: PropTypes.func,
  onCreate: PropTypes.func,
  onDelete: PropTypes.func,
  onSave: PropTypes.func,
  isForm: PropTypes.bool,
  label: PropTypes.string,
  helpText: PropTypes.string,
  canEdit:PropTypes.bool,
};

FormRelationship.defaultProps = {
  label: '',
  helpText: '',
  value: [],
  onChange: () => {},
  onCreate: () => {},
  onDelete: () => {},
  onSave: () => {},
  isForm: false,
  canEdit:true,
};

export default connect()(FormRelationship);
